// extracted by mini-css-extract-plugin
export default {"tableContainer":"ValueBar_tableContainer__RFVmn","bar":"ValueBar_bar__ZWOGC"};